import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Setting } from 'src/app/models/setting.model';
import { getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  
  isLoggedIn:boolean = false

  home:string = 'Home'
  aboutEdu:string = 'About CamEdu'
  aboutUs:string = 'About Us'
  instructor:string = 'Instructor'
  feedback:string = 'Feedback'
  usingCamedu:string = "Using CamEdu"
  courses:string = 'Courses'
  englishLesson:string = 'Lessons'
  knowledge:string = 'Knowledge'
  contact:string = 'Contact Us'
  myAccount:string = 'My Account'
  login:string = 'Login'
  register:string = 'Register'
  howToPay:string = 'How to Pay'

  @Input() setting:Setting = new Setting()

  constructor(
    private authService:AuthService
  ) { 
 
  }

  ngOnInit() {
    this.checkAuth()
    this.needTranslate()
  }

  async checkAuth(){
    let isLoggedIn = await this.authService.checkAuth();
    this.isLoggedIn = isLoggedIn !== null;
  }

  needTranslate(){
    this.aboutEdu = getLocalTranslate('about-camedu',this.aboutEdu)
    this.aboutUs = getLocalTranslate('about-us',this.aboutUs)
    this.instructor = getLocalTranslate('instructor',this.instructor)
    this.feedback = getLocalTranslate('feedback',this.feedback)
    this.usingCamedu = getLocalTranslate('using-camedu',this.usingCamedu)
    this.courses = getLocalTranslate('courses',this.courses)
    this.englishLesson = getLocalTranslate('english-lesson',this.englishLesson)
    this.knowledge = getLocalTranslate('knowledge',this.knowledge)
    this.contact = getLocalTranslate('contact-us',this.contact)
    this.myAccount = getLocalTranslate('my-account',this.myAccount)
    this.login = getLocalTranslate('login',this.login)
    this.register = getLocalTranslate('register',this.register)
    this.howToPay = getLocalTranslate('how-to-pay',this.howToPay)
  }

}
